export enum ActiveErrorDetailsSections {
  Ecu = 'Ecu',
  SystemBehavior = 'SystemBehavior',
  FreezeFrame = 'FreezeFrame',
  LiveVdd = 'LiveVdd',
}

export const dataAtTheTimeOfFaultDetectionVddName = 'FreezeFrame';
